import { atom } from "jotai";

export const apiJWTAtom = atom("")